<template>
    <nav class="mobile__navbar">
        <div class="navbar__container">
            <div class="navbar__box">
                <div
                    class="navbar__item"
                    :class="{ active: active === 'home' }"
                >
                    <router-link :to="{ name: 'home' }">
                        <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.4986 19.0002V14.0002H14.4986V19.0002C14.4986 19.5502 14.9486 20.0002 15.4986 20.0002H18.4986C19.0486 20.0002 19.4986 19.5502 19.4986 19.0002V12.0002H21.1986C21.6586 12.0002 21.8786 11.4302 21.5286 11.1302L13.1686 3.60021C12.7886 3.26021 12.2086 3.26021 11.8286 3.60021L3.46863 11.1302C3.12863 11.4302 3.33863 12.0002 3.79863 12.0002H5.49863V19.0002C5.49863 19.5502 5.94863 20.0002 6.49863 20.0002H9.49863C10.0486 20.0002 10.4986 19.5502 10.4986 19.0002Z"
                                fill="#808080"
                            />
                        </svg>

                        <span>Главная</span>
                    </router-link>
                </div>

                <div class="navbar__item ">
                    <button @click="switchCatalogVisible">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M8.90594 2H4.31281C3.03754 2 2 3.03754 2 4.31281V8.90594C2 10.1812 3.03754 11.2188 4.31281 11.2188H8.90594C10.1812 11.2188 11.2188 10.1812 11.2188 8.90594V4.31281C11.2188 3.03754 10.1812 2 8.90594 2ZM9.65625 8.90594C9.65625 9.31965 9.31965 9.65625 8.90594 9.65625H4.31281C3.8991 9.65625 3.5625 9.31965 3.5625 8.90594V4.31281C3.5625 3.8991 3.8991 3.5625 4.31281 3.5625H8.90594C9.31965 3.5625 9.65625 3.8991 9.65625 4.31281V8.90594Z"
                                fill="#808080"
                            />
                            <path
                                d="M19.6562 2H15.125C13.8327 2 12.7812 3.05141 12.7812 4.34375V8.875C12.7812 10.1673 13.8327 11.2188 15.125 11.2188H19.6562C20.9486 11.2188 22 10.1673 22 8.875V4.34375C22 3.05141 20.9486 2 19.6562 2ZM20.4375 8.875C20.4375 9.30578 20.087 9.65625 19.6562 9.65625H15.125C14.6942 9.65625 14.3438 9.30578 14.3438 8.875V4.34375C14.3438 3.91297 14.6942 3.5625 15.125 3.5625H19.6562C20.087 3.5625 20.4375 3.91297 20.4375 4.34375V8.875Z"
                                fill="#808080"
                            />
                            <path
                                d="M8.90594 12.7812H4.31281C3.03754 12.7812 2 13.8188 2 15.0941V19.6872C2 20.9625 3.03754 22 4.31281 22H8.90594C10.1812 22 11.2188 20.9625 11.2188 19.6872V15.0941C11.2188 13.8188 10.1812 12.7812 8.90594 12.7812ZM9.65625 19.6872C9.65625 20.1009 9.31965 20.4375 8.90594 20.4375H4.31281C3.8991 20.4375 3.5625 20.1009 3.5625 19.6872V15.0941C3.5625 14.6804 3.8991 14.3438 4.31281 14.3438H8.90594C9.31965 14.3438 9.65625 14.6804 9.65625 15.0941V19.6872Z"
                                fill="#808080"
                            />
                            <path
                                d="M19.6562 12.7812H15.125C13.8327 12.7812 12.7812 13.8327 12.7812 15.125V19.6562C12.7812 20.9486 13.8327 22 15.125 22H19.6562C20.9486 22 22 20.9486 22 19.6562V15.125C22 13.8327 20.9486 12.7812 19.6562 12.7812ZM20.4375 19.6562C20.4375 20.087 20.087 20.4375 19.6562 20.4375H15.125C14.6942 20.4375 14.3438 20.087 14.3438 19.6562V15.125C14.3438 14.6942 14.6942 14.3438 15.125 14.3438H19.6562C20.087 14.3438 20.4375 14.6942 20.4375 15.125V19.6562Z"
                                fill="#808080"
                            />
                        </svg>

                        <span>Каталог</span>
                    </button>
                </div>

                <div
                    class="navbar__item basket__box"
                    :class="{ active: active === 'shopcart' }"
                >
                    <router-link :to="{ name: 'shopcart' }">
                        <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M20.5 13.3503V6.17367L6.9 3.62102V2.73875C6.9 1.78001 6.1497 1 5.22743 1H3.5V2.17815H5.22739C5.52474 2.17815 5.76667 2.42964 5.76667 2.73875V13.6172C5.76667 14.873 6.74949 15.8947 7.95759 15.8947H8.41111V17.2373C8.17957 17.1318 7.92412 17.0728 7.65556 17.0728C6.61402 17.0728 5.76667 17.9537 5.76667 19.0364C5.76667 20.1191 6.61402 21 7.65556 21C8.63336 21 9.43991 20.2236 9.53496 19.2328H9.54444V15.8947H19.3667V17.2373C19.1351 17.1318 18.8797 17.0728 18.6111 17.0728C17.5696 17.0728 16.7222 17.9537 16.7222 19.0364C16.7222 20.1191 17.5696 21 18.6111 21C19.5889 21 20.3955 20.2236 20.4905 19.2328H20.5V14.7166H7.95759C7.37441 14.7166 6.9 14.2234 6.9 13.6172V13.1539L20.5 13.3503ZM7.65556 19.8219C7.23894 19.8219 6.9 19.4695 6.9 19.0364C6.9 18.6033 7.23894 18.251 7.65556 18.251C8.07217 18.251 8.41111 18.6033 8.41111 19.0364C8.41111 19.4695 8.07217 19.8219 7.65556 19.8219ZM18.6111 19.8219C18.1945 19.8219 17.8556 19.4695 17.8556 19.0364C17.8556 18.6033 18.1945 18.251 18.6111 18.251C19.0277 18.251 19.3667 18.6033 19.3667 19.0364C19.3667 19.4695 19.0277 19.8219 18.6111 19.8219ZM12.5667 12.0575L10.3 12.0248V5.45637L12.5667 5.8818V12.0575ZM13.7 6.09454L15.7778 6.48454V12.1039L13.7 12.0739V6.09454ZM9.16667 12.0084L6.9 11.9757V4.81821L9.16667 5.24364V12.0084ZM19.3667 12.1557L16.9111 12.1202V6.69724L19.3667 7.15813V12.1557Z"
                                fill="#808080"
                            />
                            <circle cx="18.5" cy="19" r="1" fill="#808080" />
                            <circle cx="7.5" cy="19" r="1" fill="#808080" />
                        </svg>

                        <span>Корзина</span>

                        <p
                            v-if="shopcardProductCounts > 0"
                            :key="'shop cart amount box'"
                        >
                            {{ shopcardProductCounts }}
                        </p>
                    </router-link>
                </div>

                <div
                    class="navbar__item"
                    :class="{ active: active === 'profile' }"
                >
                    <router-link :to="{ name: 'profile' }">
                        <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12.5 12C14.71 12 16.5 10.21 16.5 8C16.5 5.79 14.71 4 12.5 4C10.29 4 8.5 5.79 8.5 8C8.5 10.21 10.29 12 12.5 12ZM12.5 14C9.83 14 4.5 15.34 4.5 18V19C4.5 19.55 4.95 20 5.5 20H19.5C20.05 20 20.5 19.55 20.5 19V18C20.5 15.34 15.17 14 12.5 14Z"
                                fill="#808080"
                            />
                        </svg>

                        <span>Профиль</span>
                    </router-link>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    data() {
        return {
            active: "",
            catalogVisible: false
        };
    },

    methods: {
        ...mapMutations(["updateCatalogVisible"]),

        defineActivePage() {
            const loc = window.location.pathname.split("/").pop();
            if (loc === "") this.active = "home";
            if (loc === "profile") this.active = "profile";
            if (loc === "shopcart") this.active = "shopcart";
        },

        switchCatalogVisible() {
            this.catalogVisible = !this.catalogVisible;
        },

        redirectTo(route, id) {
            this.$router.push({
                name: route,
                params: {
                    id
                }
            });
        }
    },

    computed: {
        ...mapGetters(["getCatalogVisible", "shopcardProductCounts"])
    },

    watch: {
        catalogVisible(newV) {
            this.updateCatalogVisible(newV);
        },

        getCatalogVisible(newV) {
            this.catalogVisible = newV;
        },

        $route(to, from) {
            this.defineActivePage();
        }
    },

    async mounted() {
        this.defineActivePage();
        this.catalogVisible = this.getCatalogVisible;
    }
};
</script>

<style lang="scss" scoped>
.mobile__navbar {
    display: none;
}

@media only screen and (max-width: 440px) {
    .mobile__navbar {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 50;
        width: 100%;

        .navbar__container {
            display: flex;
            background-color: #f0f0f0;
            width: 100%;

            .navbar__box {
                display: flex;
                justify-content: space-around;
                padding-top: 7px;
                padding-bottom: 5px;
                width: 100%;

                .navbar__item {
                    display: flex;
                    flex-direction: column;

                    a,
                    button {
                        outline: none;
                        border: none;
                        background-color: transparent;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: space-between;

                        span {
                            display: block;
                            margin-top: 4px;

                            font-family: SF Pro, sans-serif;
                            font-style: normal;
                            font-weight: normal;
                            font-size: 15px;
                            line-height: 1;
                            /* identical to box height, or 100% */
                            text-align: center;
                            /* grey */
                            color: #808080;
                        }
                    }
                }

                .basket__box {
                    a {
                        position: relative;

                        p {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: absolute;
                            top: -10%;
                            right: 20%;
                            width: 17px;
                            height: 17px;
                            border-radius: 10px;
                            background-color: #6C9672;
                            text-align: center;
                            font-size: 12px;
                            font-family: Acrom-Medium, sans-serif;
                            color: #ffffff;
                        }
                    }
                }

                .active {
                    a,
                    button {
                        span {
                            color: #3E5C45;
                        }

                        svg {
                            path {
                                fill: #3E5C45;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
